// The sublink for the current page. A sublink with `matchChildren` also covers the pages under its
// path (e.g. a delivery profile under Auto Assign); an exact match always wins.
export const selectedSublink = (sublinks = [], pathname = '') =>
    sublinks.find((sublink) => sublink.path === pathname) ||
    sublinks.find((sublink) => sublink.matchChildren && pathname.startsWith(`${sublink.path}/`));
